// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EWJPWqiKYZp1Y_3PaTob {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.CpgLO67B_l94atQ0zzx3 {
    display: flex;
    justify-content: center;
}

.bp4B9y5ZCByosLemDaYz {
    cursor: pointer;
}

.ibgpHzxZcNat_8iJsn7R {
	text-decoration: none;
	color: inherit;
}

.ibgpHzxZcNat_8iJsn7R:hover {
	text-decoration: none;
	color: inherit;
}

.ibgpHzxZcNat_8iJsn7R:visited {
	text-decoration: none;
	color: inherit;
}

.pARwq3lcKzPgatHLXl_p, .pARwq3lcKzPgatHLXl_p:hover {
    text-decoration: none;
}

.IlBbRk_dBco2UE5MOAuY {
    flex-shrink: 0;
    width: 100px;
    height: 75px;
}`, "",{"version":3,"sources":["webpack://./src/common.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;CACC,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,cAAc;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;AAChB","sourcesContent":[".centeredColumn {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.centered {\n    display: flex;\n    justify-content: center;\n}\n\n.clickable {\n    cursor: pointer;\n}\n\n.anchorStandard {\n\ttext-decoration: none;\n\tcolor: inherit;\n}\n\n.anchorStandard:hover {\n\ttext-decoration: none;\n\tcolor: inherit;\n}\n\n.anchorStandard:visited {\n\ttext-decoration: none;\n\tcolor: inherit;\n}\n\n.link, .link:hover {\n    text-decoration: none;\n}\n\n.cardImage {\n    flex-shrink: 0;\n    width: 100px;\n    height: 75px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"centeredColumn": `EWJPWqiKYZp1Y_3PaTob`,
	"centered": `CpgLO67B_l94atQ0zzx3`,
	"clickable": `bp4B9y5ZCByosLemDaYz`,
	"anchorStandard": `ibgpHzxZcNat_8iJsn7R`,
	"link": `pARwq3lcKzPgatHLXl_p`,
	"cardImage": `IlBbRk_dBco2UE5MOAuY`
};
export default ___CSS_LOADER_EXPORT___;
